<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";
const props = defineProps<{
  name?: string;
  color?: string;
  size?: string;
  disabled?: boolean;
}>();

const emit = defineEmits(["click"]);

const styleObj = computed(() => {
  const ret: Record<string, string> = {};
  if (props.size) {
    ret.fontSize = props.size;
  }

  if (props.color) {
    ret.color = props.color;
  }

  return ret;
});

function onClick(e: any) {
  if (props.disabled) return;
  emit("click", e);
}
</script>
<template>
  <i
    class="mp-icon"
    :style="styleObj"
    :class="{ 'is-disabled': !!disabled }"
    @click="onClick"
  >
    <component class="mp-icon__svg" :is="name" />
  </i>
</template>
<style lang="scss">
.mp-icon {
  color: inherit;
  height: 1em;
  width: 1em;
  line-height: 1em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  fill: currentColor;
  font-size: inherit;

  &__svg {
    position: relative;
    vertical-align: -2px;
  }

  &.is-disabled {
    color: #c0c4cc;
  }
}
</style>
